import React from "react";
import { useCanAccess } from "../../permissions";

export default function CanAccess({ component, children }) {
  const ok = useCanAccess(component);
  if (!ok) return null;
  return <>{children}</>;
}


